import React from 'react'
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Grid } from '@material-ui/core';

import { confirmAcuerdoJudicial, getAreasLegales, getEstadosLegalesEfector } from '../../../actions/contrataciones/contratacionesLegales';
import { AreaLegal } from './AreaLegal';
import { SwitchGeneric } from '../../atomic/molecules/SwitchGeneric';
import { contratacionesActions } from '../../../reducers/contrataciones/contratacionesReducer';

export const InfoLegales = ({ fieldsDisabled }) => {
    const dispatch = useDispatch();

    const {
        estadosLegales,
        areasLegales: listaAreasLegales
    } = useSelector((state) => state.contratacionesLegales);
    const { dataContrato, acuerdoJudicial } = useSelector((state) => state.contrataciones);

    useEffect(() => {
        if ((listaAreasLegales?.length === 0))
            dispatch(getAreasLegales());
    }, [listaAreasLegales]);

    useEffect(() => {
        dispatch(getEstadosLegalesEfector());
    }, []);

    return (
        <Grid container>
            <Grid item xs={12}>
                <SwitchGeneric
                    value={acuerdoJudicial}
                    onChange={() => {
                        dispatch(confirmAcuerdoJudicial({
                            idEfectorFacturacion: dataContrato.idEfectorFacturacion,
                            acuerdoJudicial: !acuerdoJudicial
                        }, () => {
                            dispatch(contratacionesActions.acuerdoJudicial(!acuerdoJudicial));
                        }));
                    }}
                    name="acuerdoJudicial"
                    label="Acuerdo Judicial"
                />
            </Grid>
            <Grid item xs={12}>
                {listaAreasLegales.length > 0 &&
                    listaAreasLegales.map(item => {
                        return (
                            <AreaLegal
                                estadosLegales={estadosLegales}
                                area={item}
                                fieldsDisabled={fieldsDisabled}
                            />
                        )
                    })}
            </Grid>
        </Grid>
    )
}
